/*
 * @namespace Data
 * @aka COMMON.Data
 */
COMMON.Data = function ($) {

  var workers = {};

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  /**
   * @param data
   * @private
   */
  var _setStorage = function _setStorage(data) {
    $.each(data, function (key, value) {
      COMMON.Storage.session.setItem(key, value);
      $(document).trigger('common:data', {
        key: key
      })
    })
  };

  /**
   * @param url
   * @returns {*|jQuery|boolean}
   * @private
   */
  var _pull = function _pull(url) {
    return $.ajax({
      url: url,
      dataType: 'json',
      async: true
    });
  };

  /**
   * @param url
   * @private
   */
  var _update = function _update(config) {
    _pull(config.url).then(function (data) {
      if (data) {
        var response = {};
        if (config.hasOwnProperty('alias') && null !== config.alias) {
          response[config.alias] = data;
        } else {
          response = data;
        }
        _setStorage(response);
      }
    }, function (reason) {
      console.error('error in processing your request', url, reason);
    });
  };

  /**
   * @param fn
   * @returns {string}
   * @private
   */
  var _fn2workerURL = function (fn) {
    var blob = new Blob(["(" + fn.toString() + ")()"], {
      type: "application/javascript"
    });
    return URL.createObjectURL(blob);
  };

  /**
   * @private
   */
  var _feedfetcherWorker = function () {
    var _timeoutID = null;

    onmessage = function (event) {
      var that = self;
      var config;

      if (event.data) {
        config = event.data
      }
      if (!config.hasOwnProperty('url')) {
        return;
      }
      var _getData = function (url) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            try {
              var jsonResponse = JSON.parse(xhr.responseText);
              that.postMessage(jsonResponse);
            } catch (err) {
              console.log(err.message + " in " + xhr.responseText);
            }
          }
        };
        xhr.open('GET', url, true);
        //xhr.withCredentials = false;
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(null);
      };
      if (config.hasOwnProperty('interval') && null !== config.interval) {
        _timeoutID = setInterval(_getData, config.interval, config.url);
      }
      _getData(config.url);
    };

  };

  /**
   * @param id
   * @param feed
   * @private
   */
  var _subscribe = function(id, config) {
    if (workers.hasOwnProperty(id)) {
      return false;
    }

    if (window.Worker) {
      // create worker
      workers[id] = new window.Worker(_fn2workerURL(_feedfetcherWorker));

      // handle worker response
      workers[id].onmessage = function (event) {
        var data = event.data;
        if (data) {
          var response = {};
          if (config.hasOwnProperty('alias') && null !== config.alias) {
            response[config.alias] = data;
          } else {
            response = data;
          }
          _setStorage(response);
        }
      };

      // start workers with config
      workers[id].postMessage({
        url: config.url,
        interval: config.interval
      })
    } else {
      if (config.hasOwnProperty('interval') && null !== config.interval) {
        workers[id] = window.setInterval(_update, config.interval, config);
      }
      _update(config);
    }
  };

  /**
   * @param id
   * @returns {boolean}
   * @private
   */
  var _unsubscribe = function (id) {
    if (!workers.hasOwnProperty(id)) {
      return false;
    }

    if (window.Worker) {
      workers[id].terminate();
    } else {
      window.clearInterval(workers[id])
    }

    delete workers[id];

    return true;
  };


  $(document).on('common:data:subscribe', function (event, name, data) {
    COMMON.Utils.typeCheckConfig('COMMON.Data', data, {
      url: 'string',
      interval: '(undefined|null|number)',
      alias: '(undefined|null|string)'
    });

    // url must be absolute in worker
    var url = COMMON.Utils.parseUrl(data.url);
    data.url = url.protocol + '://' + url.host + ("" !== url.port ? ':' + url.port : '') + url.relative;

    _subscribe(name, data)
  });

  $(document).on('common:data:unsubscribe', function (event, name) {
    _unsubscribe(name)
  });

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Data = {
    get: function get(key) {
      return COMMON.Storage.session.getItem(key);
    }
  };

  return Data;

}(window.jQuery);
